export default __webpack_public_path__ + "static/media/checklist_icon.9fbee56d.svg";